<template>
  <div>
    <div class="container-fluid product-list-main">
      <div
        class="success_message"
        v-text="$root.success_message"
        v-if="$root.success_message != ''"
      ></div>
      <!-- <div class="error_message" v-text="this.$root.error_message" v-if="this.$root.error_message != ''"></div> -->

      <div class="row">
        <div
          class="col-12"
          sty
          v-if="
            filter_status == false &&
              category_mobile_image != '' &&
              category_mobile_image != null
          "
          style="margin-bottom: 15px"
        >
          <img :src="category_mobile_image" class="w-100" />
        </div>
        
        <div class="col-12" style="margin-bottom: 15px">
          <img :src="category_image" class="w-100 catBanner" />
        </div>
      </div>

      <div class="row" v-if="blankpage == false && pageload == false">
        <div id="sidebar-main" class="col-md-2 sidebar-main" v-if="filter_status == true">
          <nav id="sidebar-inner">
            <div class="sidebar-header">
              <h3 class="font-bold">Filters</h3> 
            </div>
            <div class="applied-filter" v-if="filtersAppied.length != 0">
              <h3>Applied Filters</h3>
              <ul>
                <li v-for="(items, index) in filterview" :key="index">
                  <a
                    href="#"
                    class="remove"
                    @click.prevent="removefilter(index)"
                    ><span>Remove This Item</span></a
                  ><span class="filter-label"></span
                  ><span v-text="items"></span>
                </li>
              </ul>
              <a
                href="#"
                class="filter-clear"
                @click.prevent="removeallfilter()"
                ><span>Clear All</span></a
              >
            </div>
            <ul v-if="!isMobile" class="list-unstyled components">
              <li
                class="filter-box"
                v-for="(filters, index1) of filters"
                :key="index1"
                :class="{ color: filters.filter_lable === 'Color' }"
              >
                <a
                  href="#"
                  @click.prevent="toggle"
                  :class="{
                    'mobile-active': filterActive(filters.filter_lable),
                  }"
                  class="active dropdown-toggle"
                  v-text="filters.filter_lable"
                ></a>
                <ul
                  class="collapse list-unstyled"
                  :class="{
                    'mobile-active': filterActive(filters.filter_lable),
                  }"
                >
                  <li
                    v-for="(option, index) in filters.options"
                    :key="index"
                    :class="option.value_key"
                  >
                    <a
                     
                      href="#"
                      v-text="option.value"
                      :class="{
                        check: isActive(option.code + '-' + option.value),
                      }"
                      @click.prevent="
                        addfilter(
                          filters.filter_lable,
                          option.code,
                          option.value,
                          option.value
                        )
                      "
                      :value="filters.filter_lable + '_' + option.value"
                     
                    ></a>
                  </li>
                  <!-- 
                     v-if="
                        (option.value != '' && (i < 5 || index < 5)) ||
                          index1 === activeValue
                      "
                    
                    <div
                    v-if="
                      filters.options.length > 5 ||
                        Object.keys(filters.options).length > 5
                    "
                  >
                    <p
                      class="filterMore"
                      v-if="activeValue == null || index1 != activeValue"
                      @click="toggleFilters(index1)"
                    >
                      View More (+{{
                        filters.options.length - 5 ||
                          Object.keys(filters.options).length - 5
                      }})
                    </p>
                    <p class="filterMore" v-else @click="toggleFilters(null)">
                      View Less
                    </p>
                  </div> -->
                </ul>
              </li>
            </ul>
            <ul v-else class="list-unstyled components">
              <li
                class="filter-box"
                v-for="(filters, index1) of filters"
                :key="index1"
                :class="{ color: filters.filter_lable === 'Color' }"
              >
                <a
                  href="#"
                  @click.prevent="toggle"
                  :class="{
                    'mobile-active': filterActive(filters.filter_lable),
                  }"
                  class="active"
                  v-text="filters.filter_lable"
                ></a>
                <ul
                  class="collapse list-unstyled"
                  :class="{
                    'mobile-active': filterActive(filters.filter_lable),
                  }"
                >
                  <li
                    v-for="(option, index) in filters.options"
                    :key="index"
                    :class="option.value_key"
                  >
                    <a
                      href="#"
                      v-text="option.value"
                      :class="{
                        check: isActive(option.code + '-' + option.value),
                      }"
                      @click.prevent="
                        addfilter(
                          filters.filter_lable,
                          option.code,
                          option.value,
                          option.value
                        )
                      "
                      :value="filters.filter_lable + '_' + option.value"
                      v-if="option.value != ''"
                    ></a>
                  </li>
                </ul>
              </li>
            </ul>
          </nav>
          <button @click="close_mobile_filter" class="apply_mobile_filter">
            Apply
          </button>
          <button @click="close_mobile_filter" class="close_mobile_filter">
            Close
          </button>
        </div>
        <div class="col-md-10 col-12 product-section-main">
            <div class="row" v-if="$root.error_message != ''">
          <div class="col-12 text-center">
            <img
              src="/img/no-product.png"
              style="width: 24%; padding: 100px 0px"
              class="img-fluid"
              alt=""
            />
          </div>
        </div>
          <div v-else class="row">
            <div class="col-md-12">
              <div class="col-md-12">
                <div class="row">
                  <div class="col-md-9 item-count">
                    <h2 v-text="categorie_name"></h2>
                  </div>
                  <div class="col-md-3 sort-item-count">
                        <div
                        class="sortDrop product-sort w-100"
                        @change="sortonChange($event)"
                      >
                        <span>
                          Sort By 
                          <span class="sortTitle">
                            : {{ select_sort_value }}</span
                          >
                          <i class="fa fa-angle-down float-right"></i>
                        </span>
                        <ul class="sortDropList">
                          <li
                            v-for="(item, index) of sort"
                            :key="index"
                            v-text="item.label"
                            v-if="item.label != 'Price'"
                            :value="item.code"
                            :class="
                              select_sort_value == item.label
                                ? 'sortActive'
                                : ''
                            "
                            @click="sortonChangeDesktop(item)"
                          ></li>
                        </ul>
                      </div>



                   
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 product-list">
              <div v-if="Product_list.length == 0 && product_loader == false" class="col-12 text-center">
                    <img
                      src="/img/wndw_coming_soon.png"
                      style="width: 24%; padding: 100px 0px"
                      class="img-fluid"
                      alt=""
                    />
                  </div>
              <div class="container-fluid">
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="error_message"
                      v-text="filter_error_msg"
                      v-if="filter_error_msg != ''"
                    ></div>
                  </div>
                  <div
                    class="col-md-3 col-sm-6 col-xs-6 col-6 pr-0"
                    v-for="(article, index) of Product_list"
                    :key="index"
                  >
                    <div class="slide-box">
                      <div class="product-box">
                        <!--div class="offer-tag">New</div-->
                        <!-- <router-link
                                                :to="{name:'detail', params:{ pro_id: article.id_product, pro_url_key:article.url_key,},
                                                query: { store: article.store }
                                                }"
                                                :key="article.id_category" class="view-detail"
                                                @click.native="gtm_product_click(article.name,article.sku,article.selling_price,article.category,index)">
                                                View Detail
                                            </router-link> -->
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: {
                              store: article.store,
                              id: article.id_product,
                            },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                        >
                     
                          <!-- <div
                            class="product_image" 
                            :style="{
                              'background-image': 'url(' + article.image.replace(' ','%20') + ')',
                            }"
                          ></div> -->
                          <img :src="article.image" class="new_product_image" :alt="article.name" :title="article.name">
                        </router-link>
                        <a
                          href="javaScript:void(0);"
                          class="listWish"
                          @click="wishlistHandler(article.id_product)"
                          ><i
                            :class="
                              productsInWishlist.includes(
                                parseInt(article.id_product)
                              )
                                ? 'fa fa-heart text-logo-color'
                                : 'fa fa-heart-o'
                            "
                          ></i>
                        </a>
                        <div class="viewDetails">
                           <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: {
                              store: article.store,
                              id: article.id_product,
                            },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                        >
                     
                          <!-- <div
                            class="product_image" 
                            :style="{
                              'background-image': 'url(' + article.image.replace(' ','%20') + ')',
                            }"
                          ></div> -->
                          View Details
                        </router-link>
                          
                        </div>
                      </div>

                      <p>
                        <router-link
                          :to="{
                            name: 'detail',
                            params: {
                              pro_id: article.id_product,
                              pro_url_key: article.url_key,
                            },
                            query: {
                              store: article.store,
                              id: article.id_product,
                            },
                          }"
                          :key="article.id_category"
                          @click.native="
                            gtm_product_click(
                              article.name,
                              article.sku,
                              article.selling_price,
                              article.category,
                              index
                            )
                          "
                          v-text="article.name"
                        ></router-link>
                      </p>
                      <!-- v-if="article.selling_price != article.price" -->
                      <div
                        class="price"
                        v-if="article.selling_price != article.price"
                      >
                        <p>
                          <span
                            class="price"
                          >{{article.selling_price | formatMoney}}  </span>
                          <span
                            class="old-price"
                          >
                          {{article.price | formatMoney}}
                          </span>
                          <span
                            class="discount_percent font-bold"
                            v-if="article.product_type == null"
                          >{{ $root.percentOff(article.price,article.selling_price)}}</span
                          >
                        </p>
                      </div>
                      <div class="price" v-else>
                        <p>
                          <span
                            class="price"
                          >
                          {{article.selling_price | formatMoney}}
                          </span>
                        </p>
                      </div>
                      <!-- <div class="size" v-if="article.product_type==null">
                                            <p>Size - <span v-for="option in article.variation"
                                                    v-text="option.configrable_atribute_value"></span> </p>
                                        </div> -->
                    </div>
                  </div>
                </div>
              </div>
              <div class="product_loader" v-show="product_loader == true">
                <loading-icon class="loading-icon newLoader" name="ball-clip-rotate-multiple" color="#ba2126" scale="1"></loading-icon>
              </div>
              <!-- <div class="list_product_loader">
                  <img src="/img/giphy.gif" />
              </div> -->
            </div>
          </div>
        </div>
        <!-- <div class="col-md-12">
                    <div class="category-description" v-html="this.description"></div>
                </div> -->
      </div>
      <div class="product_loader" v-show="pageload == true">
        <loading-icon class="loading-icon newLoader" name="ball-clip-rotate-multiple" color="#ba2126" scale="1"></loading-icon>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "Store_Products",
  metaInfo() {
    return {
      title: this.meta_title,
      meta: [
        {
          name: "description",
          content: this.meta_description,
        },
        {
          property: "keywords",
          content: this.meta_keyword,
        },
      ],
    };
  },
   computed : {
    noProduct () {
      let status = false 
      if(this.Product_list.length == 0 && this.stores.length == 0 && this.pageload == false && this.product_loader == false) {
        status = true 

      }
      return status
    }
    

  },
  data: function() {
    return {
      productsInWishlist: [],
      activeValue: null,
      meta_title: "",
      description: "",
      meta_description: "",
      meta_keyword: "",
      category_image: "",
      category_mobile_image: "",
      product_loader: true,
      Product_MoreLoad: true,
      filter_error_msg: "",
      filter_status: true,
      mobilefilterActive: "",
      isMobile: false,
      blankpage: false,
      page: 1,
      pageload: true,
      pageSize: "",
      service: "category",
      count: 20,
      id_category: this.$route.params.cat_id,
      Product_list: [],
      filters: [],
      filtersAppied: [],
      filterview: [],
      apifilter: "",
      filter_api_url: [],
      colorsActive: [],
      sizesActive: [],
      sort: [
        { code: "price_low", label: "Price (Low to High)" },
        { code: "selling_price", label: "Price (High to Low)" },
      ],
      select_sort: "product_position",
      select_sort_value: "Newest",
      pass_sort: "",
      pass_url_key: this.$route.name,
      sort_dir: "desc",
      categorie_name: "",
      current_filter: "",
      Product_count: "",
      get_product_length: "",
      gtm_product_impressions: [],
    };
  },
  methods: {
     getWish() {
      this.$root.breadcrumb = "";
      this.$root.page_loader = true;
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("type", "get");
      axios
        .post(this.$root.cart_api + `/wishlist/items`, form)
        .then((response) => {
          // console.log(response);
          if (response.data.success == true) {
            if (response.data.data == 0) {
              this.$root.wishListProducts = 0;
            }
            this.wishlistProduct = response.data.data;
            if (response.data.data) {
              this.productsInWishlist = response.data.data.map((product) => {
                return product.id_product;
              });
            }
            this.$root.page_loader = false;
          } else {
            this.$root.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cs",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
            }
          }
        });
    },
    addToWishList(id) {
      if (!this.$root.customer_id) {
        this.$root.login_popup = true;
      } else {
        var form = new FormData();
        form.append("customer_id", this.$root.customer_id);
        form.append("customer_session", this.$root.customer_session);
        form.append("type", "add");
        form.append("product_id", id);
        axios
          .post(this.$root.cart_api + `/wishlist/add-to-wishlist`, form)
          .then((res) => {
            if (res.data.success) {
              // console.log("called");
              this.productsInWishlist.push(parseInt(id));
              // this.$root.success_message = res.data.message
              // this.$root.wishListProducts = res.data.data
              this.$root.wishListProducts = this.$root.wishListProducts + 1;
              this.$toast.success(res.data.message, {
                position: "top-right",
                duration: 4000,
              });
            } else {
              // this.productsInWishlist.forEach(e => console.log('hekki', e))

              // console.log(arr);
              this.$toast.error("Product already exits in wishlist", {
                position: "top-right",
                duration: 4000,
              });
            }
          })
          .catch((err) => {
            this.$toast.error("Something went wrong", {
              position: "top-right",
              duration: 4000,
            });
            //this.$root.error_message = err.data.message
          });
      }
      // console.log(id);
    },
     remove_w(id) {
      var form = new FormData();
      form.append("customer_id", this.$root.customer_id);
      form.append("customer_session", this.$root.customer_session);
      form.append("product_id", id);
      form.append("type", "remove");
      axios
        .post(this.$root.cart_api + `/wishlist/remove-product`, form)
        .then((response) => {
          if (response.data.success == true) {
            this.productsInWishlist = this.productsInWishlist.filter(
              (el) => parseInt(el) !== parseInt(id)
            );
            if (this.$root.wishListProducts > 0) {
              this.$root.wishListProducts = this.$root.wishListProducts - 1;
            }
            this.$toast.success(response.data.message, {
              position: "top-right",
              duration: 4000,
            });
          } else {
            this.$root.page_loader = false;
            if (response.data.data.customer_session_status == false) {
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_customer",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cus_sess",
                "",
                "1y"
              );
              this.$root.customer_id = "";
              this.$root.customer_session = "";
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_cart",
                "",
                "1y"
              );
              $cookies.set(
                window.location.hostname.substring(10, 4) + "_ct_sess",
                "",
                "1y"
              );
              this.$root.cart_id = "";
              this.$root.cart_session = "";
              this.$root.cart_product = [];
            }
          }
        });
    },
    wishlistHandler(id) {
      if (this.productsInWishlist.includes(parseInt(id))) {
        this.remove_w(id);
      } else {
        this.addToWishList(id);
      }
    },
    checkWishlistedProduct (id) {
       let isWishlisted = false
      if( this.productsInWishlist.includes( parseInt(id))) {
           isWishlisted = true 

        }
        return isWishlisted 

    },
    toggleFilters(index) {
      this.activeValue = index;
    },
    sortonChangeDesktop(event) {
      this.select_sort_value = event.label;
      // console.log("event==", event);
      this.filter_error_msg = "";
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      if (event.code === "price_low") {
        this.pass_sort = "selling_price";
        this.$router.push({
          query: { ...this.$route.query, sort: "selling_price" },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "asc" } });
        this.sort_dir = "asc";
      } else {
        this.pass_sort = event.code;
        this.$router.push({
          query: { ...this.$route.query, sort: this.select_sort },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "desc" } });
        this.sort_dir = "desc";
      }
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            // service: this.service,
             service: "storeProducts",
             category: this.$route.query.category, 
            store: this.$route.query.store,
            url_key: "all",
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
            latitude: this.$root.location.lat,
            longitude: this.$root.location.long,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg = "Products Not Found";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    gtm_product_click: function(name, id, price, category, position) {
      // this.$gtm.trackEvent({
      //     event: 'productClick',
      //     category: 'pdp',
      //     action: 'productClick',
      //     label: 'Product List page',
      //     pdp: {
      //         click: {
      //             actionField: { list: this.categorie_name },
      //             product: [{
      //                 name: name,
      //                 id: id,
      //                 price: price,
      //                 category: category,
      //                 position: position + 1
      //             }]
      //         }
      //     }
      // });
    },
    filterActive: function(item) {
      return this.mobilefilterActive === item;
    },
    close_mobile_filter: function() {
      this.filter_status = false;
    },
    toggle: function(event) {
      event.target.classList.toggle("active");
      if (screen.width < 768) {
        this.mobilefilterActive = event.target.text;
      }
    },
    filter_show: function() {
      this.filter_status = true;
    },
    getProductList() {
      this.pageload = false
      if (this.$route.name === "collections") {
        this.service = "collections";
        this.pass_url_key = this.$route.params.url_key;
      }
      var loader_el = document.querySelector(".product_loader");
      var loader_position = loader_el.offsetTop;
      this.filter_error_msg = "";
      if (
        window.scrollY >= loader_position - 1000 &&
        this.Product_MoreLoad === true
      ) {
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.Product_MoreLoad = false;
        axios.get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "storeProducts",
              store: this.$route.query.store,
              category: this.$route.query.category,
              url_key: "all",
              page: this.page,
              count: this.count,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
              
            },
          })

          .then((response) => {
            if (response.data.response.success === 1) {
              if (response.data.result.products.length === 0) {
                this.filter_error_msg = "No product found, please try by removing last applied filter.";
              }

              this.description = response.data.result.description;
              this.meta_title = response.data.result.meta_title;
              this.meta_description = response.data.result.meta_description;
              this.meta_keyword = response.data.result.meta_keyword;
              this.category_image = response.data.result.image;
              this.category_mobile_image = response.data.result.mobile_image;
              this.Product_list = [];
              this.Product_list = this.Product_list.concat(
                response.data.result.products
              );
              this.gtm_product_impressions = [];

              for (let i = 0; i < response.data.result.products.length; i++) {
                let name = response.data.result.products[i].name;
                let id = response.data.result.products[i].sku;
                let price = response.data.result.products[i].selling_price;
                let category = response.data.result.products[i].category;
                let list = response.data.result.name;
                let position = i + 1;
                this.gtm_product_impressions.push({
                  name,
                  id,
                  price,
                  category,
                  list,
                  position,
                });
              }

              // this.$gtm.trackEvent({
              //     event: 'impressionSent',
              //     category: 'Listing',
              //     action: 'Product Impression',
              //     label: 'Product List page',
              //     listing: {
              //         currencyCode: 'INR',
              //         product: this.gtm_product_impressions
              //     }
              // });
             
              this.filters = response.data.result.filters;
              this.mobilefilterActive = response.data.result.filters[0].filter_lable;
              this.sort = this.sort.concat(response.data.result.sort);
              this.categorie_name = response.data.result.name;
              this.$root.breadcrumb = response.data.result.name;
              this.$root.breadcrumb_second.name = response.data.result.parent_name;
              this.$root.breadcrumb_second.url = response.data.result.parent_url_key;
              this.Product_count = response.data.result.count;
              this.pageSize = response.data.result.count / this.count;
              this.get_product_length = response.data.result.products.length;
              if (this.get_product_length >= this.count) {
                this.page++;
                this.Product_MoreLoad = true;
              } else {
                this.product_loader = false;
              }
            } else {
              this.$root.error_message = response.data.response.error_message;
              this.product_loader = false;
              this.blankpage = true;
              this.pageload = false;
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
          });
      } 
    },
    product_lazy_loading() {
      var loader_el = document.querySelector(".product_loader");
      var loader_position = loader_el.offsetTop;
      this.filter_error_msg = "";
      if (
        window.scrollY >= loader_position - 1000 &&
        this.Product_MoreLoad === true &&
        this.page != 1
      ) {
        this.product_loader = true
        this.$root.error_message = "";
        this.$root.success_message = "";
        this.Product_MoreLoad = false;
        axios
          .get(this.$root.api_url + `/pim/pimresponse.php`, {
            params: {
              service: "storeProducts",
              store: this.$route.query.store,
              category: this.$route.query.category,
              url_key: "all",
              page: this.page,
              count: this.count,
              sort_by: this.pass_sort,
              sort_dir: this.sort_dir,
              filter: this.apifilter,
            },
          })

          .then((response) => {
            if (response.data.response.success === 1) {
               this.product_loader = false
              if (response.data.result.products.length === 0) {
                this.filter_error_msg =
                  "No product found, please try by removing last applied filter.";
              }
              this.meta_title = response.data.result.meta_title;
              this.meta_description = response.data.result.meta_description;
              this.meta_keyword = response.data.result.meta_keyword;
              this.Product_list = this.Product_list.concat(
                response.data.result.products
              );
              this.gtm_product_impressions = [];
              for (let i = 0; i < response.data.result.products.length; i++) {
                let name = response.data.result.products[i].name;
                let id = response.data.result.products[i].sku;
                let price = response.data.result.products[i].selling_price;
                let category = response.data.result.products[i].category;
                let list = response.data.result.name;
                let position = i + 1;
                this.gtm_product_impressions.push({
                  name,
                  id,
                  price,
                  category,
                  list,
                  position,
                });
              }
              // this.$gtm.trackEvent({
              //     event: 'impressionSent',
              //     category: 'Listing',
              //     action: 'Product Impression',
              //     label: 'Product List page',
              //     listing: {
              //         currencyCode: 'INR',
              //         product: this.gtm_product_impressions
              //     }
              // });
              this.mobilefilterActive =
                response.data.result.filters[0].filter_lable;
              this.categorie_name = response.data.result.name;
              this.Product_count = response.data.result.count;
              this.pageSize = response.data.result.count / this.count;
              this.get_product_length = response.data.result.products.length;
              this.pageload = false;
              if (this.get_product_length >= this.count) {
                this.page++;
                this.Product_MoreLoad = true;
              } else {
                this.product_loader = false;
              }
            } else {
               
              this.$root.error_message = response.data.response.error_message;
              this.product_loader = false;
              this.blankpage = true;
              this.pageload = false;
            }
          })
          .catch((error) => {
            if (error.message === "Network Error") {
              this.$root.error_message =
                "Oops there seems to be some Network issue, please try again.";
            }
          });
      }
    },
    sortonChange(event) {
      this.filter_error_msg = "";
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      if (event.target.value === "price_low") {
        this.pass_sort = "selling_price";
        this.$router.push({
          query: { ...this.$route.query, sort: "selling_price" },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "asc" } });
        this.sort_dir = "asc";
      } else {
        this.pass_sort = event.target.value;
        this.$router.push({
          query: { ...this.$route.query, sort: this.select_sort },
        });
        this.$router.push({ query: { ...this.$route.query, dir: "desc" } });
        this.sort_dir = "desc";
      }
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "storeProducts",
            store: this.$route.query.store,
            category: this.$route.query.category,
            url_key: "all",
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg = "Products Not Found";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    removefilter: function(index) {
      this.filter_error_msg = "";
      // console.log(index, this.filtersAppied[index], this.filterview[index]);
      this.filtersAppied.splice(index, 1);
      this.filterview.splice(index, 1);
      this.apifilter = "";
      for (var i = 0; i < this.filtersAppied.length; i++) {
        this.apifilter += this.filtersAppied[i].replace(/\s+/g, "+");
        if (i < this.filtersAppied.length - 1) {
          this.apifilter += ",";
        }
      }
      this.$router.push({
        query: { ...this.$route.query, filter: this.filtersAppied.toString() },
      });
      window.scrollTo(0, 0);
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "storeProducts",
            store: this.$route.query.store,
            category: this.$route.query.category,
            url_key: "all",
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg =
                "No product found, please try by removing last applied filter.";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    removeallfilter: function() {
      this.filter_error_msg = "";
      this.filtersAppied = [];
      this.apifilter = "";
      this.filterview = [];
      window.scrollTo(0, 0);
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      this.$root.error_message = "";
      this.$root.success_message = "";
      this.$router.push({ query: { ...this.$route.query, filter: "" } });
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "storeProducts",
            store: this.$route.query.store,
            category: this.$route.query.category,
            url_key: "all",
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
          },
        })

        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg =
                "No product found, please try by removing last applied filter.";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    addfilter: function(label, element, value, value_key) {
      this.filter_error_msg = "";
      if (this.filtersAppied.indexOf(element + "-" + value) > -1) {
        for (let i = 0; i < this.filtersAppied.length; i++) {
          if (this.filtersAppied[i] === element + "-" + value) {
            this.filtersAppied.splice(i, 1);
            this.filterview.splice(i, 1);
          }
        }
      } else {
        this.filtersAppied.push(element + "-" + value);
        this.filterview.push(label + ": " + value);
      }
      this.apifilter = "";
      for (var i = 0; i < this.filtersAppied.length; i++) {
        this.apifilter += this.filtersAppied[i].replace(/\s+/g, "+");
        if (i < this.filtersAppied.length - 1) {
          this.apifilter += ",";
        }
      }
      this.$router.push({
        query: { ...this.$route.query, filter: this.filtersAppied.toString() },
      });
      window.scrollTo(0, 0);
      this.Product_MoreLoad = true;
      this.product_loader = true;
      this.Product_list = [];
      this.page = 1;
      this.$root.error_message = "";
      this.$root.success_message = "";
      axios
        .get(this.$root.api_url + `/pim/pimresponse.php`, {
          params: {
            service: "storeProducts",
            store: this.$route.query.store,
            category: this.$route.query.category,
            url_key: "all",
            page: this.page,
            count: this.count,
            sort_by: this.pass_sort,
            sort_dir: this.sort_dir,
            filter: this.apifilter,
          },
        })
        .then((response) => {
          if (response.data.response.success === 1) {
            if (response.data.result.products.length === 0) {
              this.filter_error_msg =
                "No product found, please try by removing last applied filter.";
            }
            this.Product_list = [];
            this.Product_list = this.Product_list.concat(
              response.data.result.products
            );
            this.gtm_product_impressions = [];
            for (let i = 0; i < response.data.result.products.length; i++) {
              let name = response.data.result.products[i].name;
              let id = response.data.result.products[i].sku;
              let price = response.data.result.products[i].selling_price;
              let category = response.data.result.products[i].category;
              let list = response.data.result.name;
              let position = i + 1;
              this.gtm_product_impressions.push({
                name,
                id,
                price,
                category,
                list,
                position,
              });
            }
            // this.$gtm.trackEvent({
            //     event: 'impressionSent',
            //     category: 'Listing',
            //     action: 'Product Impression',
            //     label: 'Product List page',
            //     listing: {
            //         currencyCode: 'INR',
            //         product: this.gtm_product_impressions
            //     }
            // });
            this.categorie_name = response.data.result.name;
            this.Product_count = response.data.result.count;
            this.pageSize = response.data.result.count / this.count;
            this.get_product_length = response.data.result.products.length;
            if (this.get_product_length >= this.count) {
              this.page++;
              this.Product_MoreLoad = true;
            } else {
              this.product_loader = false;
            }
          } else {
            this.$root.error_message = response.data.response.error_message;
            this.product_loader = false;
          }
        })
        .catch((error) => {
          if (error.message === "Network Error") {
            this.$root.error_message =
              "Oops there seems to be some Network issue, please try again.";
          }
        });
    },
    isActive: function(menuItem) {
      return this.filtersAppied.indexOf(menuItem) > -1;
    },
  },
  mounted() {
    this.$root.menuActive = true
    this.$root.error_message = ""
    this.$root.success_message = ""
    this.$root.page_loader = false
    this.getProductList();
    $cookies.set(
      window.location.hostname.substring(10, 4) + "_last_list_path",
      this.$route.fullPath
    );
  },
  created() {
    let bodyTag = document.getElementsByTagName("body");
    bodyTag[0].classList.add("m_bottom");

    if (screen.width < 767) {
      this.isMobile = true;
    }
    // console.log(screen.width);
    if (screen.width <= 767) {
      this.filter_status = false;
    }
    if (this.$route.query.filter) {
      this.filtersAppied = this.$route.query.filter.split(",");
      this.filterview = this.$route.query.filter.replace(/-/g, ": ").split(",");
      this.apifilter = "";
      for (var i = 0; i < this.filtersAppied.length; i++) {
        this.apifilter += this.filtersAppied[i].replace(/\s+/g, "+");
        if (i < this.filtersAppied.length - 1) {
          this.apifilter += ",";
        }
      }
    }
    if (this.$route.query.sort) {
      if (
        this.$route.query.sort === "selling_price" &&
        this.$route.query.dir == "asc"
      ) {
        this.select_sort = "price_low";
        this.pass_sort = "selling_price";
        this.sort_dir = "asc";
      } else {
        this.select_sort = this.$route.query.sort;
        this.pass_sort = this.$route.query.sort;
        this.sort_dir = "desc";
      }
    }
    //window.scrollTo(0, 0);

    window.addEventListener("scroll", this.product_lazy_loading);

    this.enterCreated = true; 
    
    let scrollPos = 0;
    let top_set_offset = 0;
    window.addEventListener("scroll", function sidebarfixed() {
      if (window.innerWidth > 767) {
        let offsetHeight = document.getElementById("sidebar-inner")
          .offsetHeight;
        let window_height = window.innerHeight;
        let mainoffsetHeight = document.getElementById("sidebar-main")
          .offsetHeight;
        let offsetTop = document.getElementById("sidebar-inner").offsetTop;
        let pageoffsetTop = window.pageYOffset;
        let topscroll = document.documentElement.scrollTop;
        if (document.body.getBoundingClientRect().top > scrollPos) {
          if (window_height - 75 < offsetHeight) {
            if (top_set_offset + 135 < topscroll) {
              document
                .getElementById("sidebar-inner")
                .classList.remove("bottom");
              document.getElementById("sidebar-inner").classList.remove("top");
              document.getElementById("sidebar-inner").style.position =
                "relative";
              document.getElementById("sidebar-inner").style.top =
                offsetTop + "px";
            } else {
              document.getElementById("sidebar-inner").classList.add("top");
              document
                .getElementById("sidebar-inner")
                .classList.remove("bottom");
              document.getElementById("sidebar-inner").style.position =
                "sticky";
              document.getElementById("sidebar-inner").style.top = "115px";
            }
          }
        } else {
          if (window_height - 115 < offsetHeight) {
            top_set_offset = document.getElementById("sidebar-inner").offsetTop;
            if (topscroll < offsetHeight + offsetTop + 115) {
              document.getElementById("sidebar-inner").classList.add("bottom");
              document.getElementById("sidebar-inner").classList.remove("top");
              document.getElementById("sidebar-inner").style.position =
                "sticky";
              document.getElementById("sidebar-inner").style.top = "auto";
              document.getElementById("sidebar-inner").style.bottom = "10px";
            }
          } else {
            document.getElementById("sidebar-inner").classList.add("top");
            document.getElementById("sidebar-inner").classList.remove("bottom");
            document.getElementById("sidebar-inner").style.position = "sticky";
            document.getElementById("sidebar-inner").style.top = "115px";
          }
        }
        scrollPos = document.body.getBoundingClientRect().top;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.product_lazy_loading);
  },
};
</script>
<style scoped>
.filterMore {
  color: var(--main-color);
  font-size: 15px;
  font-family: 'lhmSemiBold';
  /* text-align: center; */
  margin-top: 14px;
  margin-left: 25px;
  cursor: pointer;
}
.product-list-main .sidebar-main .filter-box .list-unstyled a:hover:before {
  background-color: var(--main-color);
}
.product-list-main .sidebar-main .filter-box .list-unstyled a.check:before {
  background-color: var(--main-color);
  color: #fff;
  content: url(/img/Vector.png);

  padding: 1.5px;
}
.product-list-main .mobile-filter {
  background-color: #fff;
  color: #626262 !important;
}
@media screen and (max-width: 767px) {
  /* .product-sort ,.apply_mobile_filter {
    background: red;
} */
  .close_mobile_filter {
    border: 1px solid #fff;
    color: #626262;
  }
  .product-list-main .sidebar-main .filter-box .list-unstyled {
    max-height: none !important;
    overflow: none !important;
  }
  .dropdown-toggle::after {
    display: none !important;
    width: 0;
    height: 0;
    margin-left: 0.255em;
    vertical-align: 0.255em;
    content: "";
    border-top: 0.3em solid;
    border-right: 0.3em solid transparent;
    border-bottom: 0;
    border-left: 0.3em solid transparent;
  }
}
</style>
